import styled from "@emotion/styled";
import { getInputFieldHeightValue } from "../../../util/inputFieldBaseProps";
import { formInputTheme } from "./formInputTheme";
export const TextInputRootBase = styled("div")`
    display: flex;
    align-items: center;
    box-sizing: border-box;
    height: ${_ref => {
  let {
    themeMode,
    inputFieldHeight
  } = _ref;
  return `var(--sds--form--height--${inputFieldHeight === 32 ? "default" : "large"}, ${formInputTheme.height[getInputFieldHeightValue(themeMode, inputFieldHeight)](themeMode)}px)`;
}};
    color: var(--sds--form--color--value);
`;
//# sourceMappingURL=TextInputRootBase.js.map